import { StyleSheet, Page, View, Text, Image } from '@react-pdf/renderer';
import strings from '@/language/Swedish';
import StaticMapImg from '@/helpers/StaticMap';
import {
  formatPrice,
  getAboutListItems,
  getSelectedRefSqmPrice,
} from '@/helpers';
import Footer from './footer';
import Header from './Header';
import { UserCustomerType } from '@/types/apiTypes';

interface InfoPageProps {
  project: any;
  refData: any;
  soldMarkerObjects: any;
  currentCoordinates: any;
  reportSettings: any;
  username: string;
  hideClientData: boolean;
  customer: UserCustomerType;
}

const InfoPage = ({
  project,
  refData,
  soldMarkerObjects,
  currentCoordinates,
  reportSettings,
  username,
  hideClientData,
  customer
}: InfoPageProps) => {
  const styles = StyleSheet.create({
    wrapper: {
      padding: '6mm',
      paddingTop: 0,
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      marginTop: '6mm',
      gap: '6mm',
      height: "70%"
    },
    left: { width: '60%',height: "100%", overflow: "hidden" },
    right: { width: '40%', height: "100%",overflow: "hidden" },
    rightWrapper: { marginBottom: 20 },
    rightWrapperHeaderText: { fontWeight: 500, fontFamily: 'Chivo' },
    listItemsWrapper: { display: 'flex', flexDirection: 'row', marginBottom: 5 },
    listItemsPropText: {
      width: '50%',
      fontFamily: 'Chivo',
      fontSize: 14,
      color: 'rgba(0,0,0,0.5)',
      fontWeight: 400,
    },
    listITemValueText: {
      width: '50%',
      fontFamily: 'Chivo',
      fontSize: 14,
      fontWeight: 400,
    },
    hr: {
      width: '100%',
      height: 1,
      backgroundColor: 'rgba(0,0,0,0.2)',
      marginTop: 10,
      marginBottom: 10,
    },
    infoText: { fontFamily: 'Chivo', fontSize: 14, color: 'rgba(0,0,0,0.5)' },
    infoTextvalue: {
      fontFamily: 'Chivo',
      fontSize: 14,
      color: "black",
      fontWeight: 400,
    },
  });
  const listItems = getAboutListItems(refData);

  const selectedMarkers =
    project.soldTableIds.selected && project.soldTableIds.selected.size > 0
      ? soldMarkerObjects?.filter(({ id }:any) =>
          project?.soldTableIds?.selected?.has(id)
        )
      : soldMarkerObjects;

  const priceSqm =
    project.referencePrice && project.referencePrice.sqmPrice
      ? project.referencePrice.sqmPrice
      : 0;
  const calculatedRef = refData.living_area_reference
    ? priceSqm * refData.living_area_reference
    : 0;
  const staticMapUrl = StaticMapImg({
    coordinatesSetting: currentCoordinates,
    zoomSetting: null,
    markers: hideClientData ? null : selectedMarkers,
    size: "600x500"
  });
  const selectedRefSqmPrice =
    project.soldTableData &&
    getSelectedRefSqmPrice(
      project.soldTableData,
      project.soldTableIds.selected
    ) || 0;
    
  const calculatedSelectedRef = refData.living_area_reference
    ? selectedRefSqmPrice * refData.living_area_reference
    : 0;
  return (
    <Page size="A4" orientation="landscape">
      <>
        <Header title={project.name} bgColor={customer?.primary_color} logo={customer?.logo_url} />
        <View style={styles.wrapper}>
          <View style={styles.left}>
            <Image src={staticMapUrl} />
          </View>
          <View style={styles.right}>
            <View style={styles.rightWrapper}>
              <Text style={styles.rightWrapperHeaderText}>
                {strings.report.about}
              </Text>
            </View>
            {listItems
              .filter((item) => item.value)
              .map(({ title, value }) => {
                return (
                  <View style={styles.listItemsWrapper} key={title}>
                    <Text style={styles.listItemsPropText}>{title}:</Text>
                    <Text style={styles.listITemValueText}>{value}</Text>
                  </View>
                );
              })}
            <View style={styles.hr} />
            {reportSettings?.showRefPrice && selectedRefSqmPrice === 0 && (
              <>
                <Text style={styles.infoText}>{`${strings.report.referencePrice1}${soldMarkerObjects?.length}${strings.report.referencePrice2}`}</Text>
                <Text style={styles.infoTextvalue}>
                  {`${formatPrice(calculatedRef) || '10000'}kr `}
                  {`(${formatPrice(priceSqm) || '100'}kr/m²)`}
                </Text>
                <View style={styles.hr} />
              </>
            )}

            {reportSettings?.showRefPrice && selectedRefSqmPrice !== 0 && (
              <>
                <Text
                  style={
                    styles.infoText
                  }>{`${strings.report.referencePrice1}${project.soldTableIds.selected?.size} ${strings.report.referencePrice2}`}</Text>
                <Text style={styles.infoTextvalue}>
                  {`${formatPrice(calculatedSelectedRef) || '10000'}kr `}
                  {`(${formatPrice(selectedRefSqmPrice) || '100'}kr/m²)`}
                </Text>
                <View style={styles.hr} />
              </>
            )}

            <Text style={styles.infoText}>{strings.report.pdfcomment}</Text>
            <Text style={styles.infoTextvalue}>{project.reportComment}</Text>
          </View>
        </View>
      </>
      <Footer username={username} hideClientData={hideClientData} />
    </Page>
  );
};

export default InfoPage;
